import React from 'react';
import '../../assets/styles/product.price.css';
import { getFormattedPriceParts, taxMultiplier } from '../../utils/priceUtils';

const TotalPrice = ({ price, qty = 0, taxPercentage = 0, size = 'medium', className = '' }) => {
    const fullPrice = taxPercentage > 0 ? price * taxMultiplier(taxPercentage) : price;

    const [baseInt, baseCents] = getFormattedPriceParts(fullPrice);
    const [finalQtyInt, finalQtyCents] = getFormattedPriceParts(fullPrice * qty);

    return (
        <div className={`ProductPrice-container price-${size} ${className}`}>
            <div className="ProductCard-original">
                <span>
                    ${baseInt}
                    <span className="ProductCard-cents">.{baseCents}</span>
                </span>
            </div>

            {qty > 0 && (
                <>
                    <div className="ProductCard-original">
                        <span> x {qty} = &nbsp; </span>
                        <span>
                            ${finalQtyInt}
                            <span className="ProductCard-cents">.{finalQtyCents}</span>
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

export default TotalPrice;
